const baseURL = "https://testupd.geezdata.com/api/";
const reportURL = "https://testtask.shopspade.com/api/";
const omsURL = "https://testoms.geezdata.com/oms_api/";
const shopURL = "https://testshop.shopspade.com/api/";

export { baseURL, reportURL, omsURL, shopURL }
